var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orgSelect" },
    [
      _c(
        "el-select",
        {
          attrs: { value: _vm.ORG_ID, placeholder: "" },
          on: { change: _vm.handleSelected }
        },
        _vm._l(_vm.orgOptions, function(item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }